import { HttpHandler } from 'msw'

import { priceTables } from './priceTables'
import { products } from './products'
import { suppliers } from './suppliers'

export const catalogue: HttpHandler[] = [
    ...priceTables,
    ...products,
    ...suppliers,
]
